import { YhPageHeader } from "@/erp_subpackage/components/YhPageHeader";
import { useDictModel } from "@/erp_subpackage/pages/base/dict/dictModel";
import { DictCodeEnmu } from "@/erp_subpackage/utils/DictCodeEnum";
import React from "react";
import { useTranslation } from 'react-i18next';
import { useWarehouseModel } from "../warehouseModel";
export function PageHeader() {
    const { t } = useTranslation();
    const {
        searchParam, organType,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useWarehouseModel();
    // const { orgDs } = useGlobalModel(({ orgDs }) => [orgDs]);
    const { getSelectedDictOne } = useDictModel(() => []);

    const searchFields = [
        // ...(organType ? [{
        //     type: "Select",
        //     placeholder: "所属机构",
        //     fieldName: "shopId",
        //     options: orgDs
        // }] : []),
        {
            type: "Select",
            placeholder: t(`base.view.PageHeader.仓库类型`),
            fieldName: "typeCode",
            options: [...getSelectedDictOne(DictCodeEnmu.WAREHOUSE_TYPE), { label: t(`base.view.PageHeader.全部仓库`), value: t(`base.view.PageHeader.全部仓库`) }]
        },
        {
            type: "Input",
            placeholder: t(`base.view.PageHeader.仓库名称`),
            fieldName: "name"
        }
    ]

    return (
        <YhPageHeader
            title= {t(`base.view.PageHeader.仓库管理`)}
            size="small"
            triggerSearch
            searchValues={searchParam}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={(params) => { loadData({ pageNum: 1 }, { ...searchParam, ...params }) }}
            handleReset={resetSearchParam}
        />
    );
}